// extracted by mini-css-extract-plugin
export var chatHtmlText = "_th-2";
export var chatLink = "_th-0";
export var chatText = "_th-1";